import { render, staticRenderFns } from "./ChoosePublications.vue?vue&type=template&id=225b4a00&"
import script from "./ChoosePublications.vue?vue&type=script&lang=js&"
export * from "./ChoosePublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports